export default class groupRequest {
  constructor(service) {
    this.service = service;
  }

  getGroupList$() {
    return this.service
      .fetch$({
        method: 'GET',
        url: '/group',
      });
  }
}
